/*! (c) Softem | MIT license */
import axios from "axios";
import { NonRedirect404ResponseHandler } from "./NonRedirect404ResponseHandler";
import { WebApi } from "./WebApi";
/**
 * WebApiを継承し、ステータスコード404のレスポンスに対してエラー画面に遷移させないようにしたWebApiです。
 */
class NonRedirect404WebApi {
    static responseHandler = new NonRedirect404ResponseHandler();
    static async request(config) {
        config.method = config.method ?? "get";
        const response = await WebApi.http.request(config);
        return NonRedirect404WebApi.responseHandler.handle(response, config);
    }
    static async getFileBlob(config) {
        config.responseType = "blob";
        const response = await WebApi.http.request(config);
        return NonRedirect404WebApi.responseHandler.handle(response, config);
    }
    static async getFileBlobAndFileName(config) {
        config.responseType = "blob";
        const response = await WebApi.http.request(config);
        const data = NonRedirect404WebApi.responseHandler.handle(response, config);
        let fileName;
        // 正規表現でヘッダからファイル名を取得する
        const match = response.headers["content-disposition"].match(/filename\*=UTF-8''([^;]+)/);
        if (match) {
            fileName = decodeURIComponent(match[1]);
        }
        return { data, fileName };
    }
}
export { axios, NonRedirect404WebApi };
